import React from 'react';
import { observer } from 'mobx-react-lite';
import { Popup } from 'src/domains/layouts/shared/popup/Popup';
import { FilesState } from 'src/AppState/FilesState/FilesState';
import { FileItemComponent } from 'src/components/FilesPopup/FileItemComponent';
import { HeaderWrapper, HeaderTitle, CrossButton, ImagesContainer } from 'src/components/FilesPopup/FilesPopup.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

interface FilesPopupPropsType {
    dataTest?: string;
    filesState: FilesState;
    onChooseImage: (id: string) => void;
    onDeleteImage: (id: string) => void;
    title: string;
    hideDeleteButton?: boolean;
}

export const FilesPopup = observer(
    ({ filesState, title, onChooseImage, onDeleteImage, dataTest, hideDeleteButton }: FilesPopupPropsType) => {
        const sortedImages = filesState.imagesList.sort((a, b) => b.time_created - a.time_created);
        return (
            <Popup
                width={1020}
                height={700}
                handleHidePopup={filesState.handleHidePopup}
                data-test={dataTest}
            >
                <>
                    <HeaderWrapper>
                        <HeaderTitle>{title}</HeaderTitle>
                        <CrossButton onClick={filesState.handleHidePopup} />
                    </HeaderWrapper>

                    <ImagesContainer>
                        <Loader isActive={filesState.isLoading} />

                        {sortedImages.map((elem) => {
                            return (
                                <FileItemComponent
                                    key={elem.id}
                                    file={elem}
                                    filesState={filesState}
                                    onChooseImage={onChooseImage}
                                    onDeleteImage={onDeleteImage}
                                    dataTest={`image-pick-${elem.id}`}
                                    hideDeleteButton={hideDeleteButton}
                                />
                            );
                        })}
                    </ImagesContainer>
                </>
            </Popup>
        );
    }
);
